import Vue from "vue";

const notify = {
  error: (title, text) => {
    Vue.notify({
      group: "main",
      type: "error",
      title,
      text,
    });
  },

  success: (title, text) => {
    Vue.notify({
      group: "main",
      type: "success",
      title,
      text,
    });
  },

  info: (title, text) => {
    Vue.notify({
      group: "main",
      type: "info",
      title,
      text,
    });
  },

  warn: (title, text) => {
    Vue.notify({
      group: "main",
      type: "warn",
      title,
      text,
    });
  },

  studio: (title, text) => {
    Vue.notify({
      group: "studio",
      type: "info",
      title,
      text,
    });
  },
};

export default notify;
